var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from './loading-spinner.styles';
export var LoadingSpinner = function (_a) {
    var className = _a.className, size = _a.size, spinnerColor = _a.spinnerColor, backgroundColor = _a.backgroundColor;
    return (_jsx("div", __assign({ className: "".concat(styles.spinnerContainer, " ").concat(className) }, { children: _jsx("div", { className: styles.getSpinnerClass(size, spinnerColor, backgroundColor) }) })));
};
export default LoadingSpinner;
//# sourceMappingURL=loading-spinner.js.map